
import { ref, computed, onMounted } from "vue";
import { trackVisits } from "@/api";

let isInitialized = false; 

export function useVisitTracker() {
  // State
  const hasTrackedToday = ref(false);
  const isLoading = ref(false);
  const error = ref(null);

  // Stable date format: YYYY-MM-DD
  const today = computed(() =>
    new Date().toISOString().slice(0, 10)
  );

  // Check localStorage
  const checkTrackingStatus = () => {
    const lastTrackedDate = localStorage.getItem("lastTrackedDate");
    hasTrackedToday.value = lastTrackedDate === today.value;
  };

  // Track visit (ONCE per day)
  const trackVisit = async () => {
    if (hasTrackedToday.value) {
      // console.log("Visit already tracked today.");
      return;
    }

    isLoading.value = true;
    error.value = null;

    try {
      await trackVisits();

      localStorage.setItem("lastTrackedDate", today.value);
      hasTrackedToday.value = true;

      // console.log("Visit tracked successfully.");
    } catch (err) {
      error.value = err;
      console.error("Visit tracking failed:", err);
    } finally {
      isLoading.value = false;
    }
  };

  // Run once (even in Vue dev strict mode)
  onMounted(() => {
    if (isInitialized) return;
    isInitialized = true;

    checkTrackingStatus();
    trackVisit();
  });

  return {
    hasTrackedToday,
    isLoading,
    error,
    trackVisit,
  };
}

